import { Noun } from '../../types'

const хуета: Noun = {
  type: 'noun',
  nominativeSingular: 'хуета',
  genitiveSingular: 'хуеты',
  dativeSingular: 'хуете',
  accusativeSingular: 'хуету',
  instrumentalSingular: 'хуетой',
  prepositionalSingular: 'хуете',
  nominativePlural: 'хуеты',
  genitivePlural: 'хует',
  dativePlural: 'хуетам',
  accusativePlural: 'хуеты',
  instrumentalPlural: 'хуетами',
  prepositionalPlural: 'хуетах',
}

export default хуета
